import { useState } from "react";
import { ProductStatus } from "onnit-ui/lib/@types/enums/ProductStatus";
import { getProductStatus } from "onnit-ui/lib/buybox/utils";
import { getUrlParameter } from "onnit-ui/lib/utils";
export function useSelectedProduct(products) {
    var _a = useState(function () {
        products.sort(function (a, b) {
            return a.in_stock === b.in_stock ? 0 : a.in_stock ? -1 : 1;
        });
        var pid = getUrlParameter("pid");
        if (pid) {
            var match = products.find(function (prod) { return prod && prod.id === Number(pid); });
            if (match) {
                return match;
            }
        }
        var inStockProducts = products.filter(function (product) {
            return getProductStatus(product) === ProductStatus.InStock;
        });
        if (inStockProducts.length > 0) {
            return inStockProducts[0];
        }
        return products[0];
    }), selectedProduct = _a[0], setProduct = _a[1];
    return {
        setProduct: setProduct,
        selectedProduct: selectedProduct
    };
}
//# sourceMappingURL=useSelectedProduct.js.map